import React, { useEffect, useMemo, useState } from "react"
import { Container, UncontrolledTooltip } from "reactstrap"
import eye from "../../assets/images/icons/eye.svg"
import downloadIcon from "../../assets/images/downloadGrey.svg"
import { formatAmount, getTableSortingHeaderIcon } from "helpers/common"
import TableContainer from "components/Common/TableContainer"
import { useLazyGetInvestorcommissionWpQuery } from "store/api/wealthpartnerapi/wealthReport"
import Breadcrumb from "components/Common/Breadcrumb"
import DefaultAvatar from "components/CommonForBoth/TopbarDropdown/DefaultAvatar"
import { Link } from "react-router-dom"

const defaultFilters = {
  search: "",
  page: 1,
  pageSize: 20,
}

const InvestorCommissionReports = () => {
  const [trigger] = useLazyGetInvestorcommissionWpQuery()
  const [filters, setFilters] = useState(defaultFilters)
  const [data, setData] = useState([])
  const [open, setOpen] = useState(false)
  document.title = `Commision Report | Prachay`

  const getList = async () => {
    try {
      const { data, success } = await trigger().unwrap()
      if (success) {
        setData(data)
      }
    } catch (error) { }
  }

  useEffect(() => {
    getList()
  }, [])

  const columns = useMemo(() => {
    const headers = [
      {
        header: "Name of Investor",
        accessorKey: "name",
        enableColumnFilter: false,
        enableSorting: false,
        cell: ({ row }) => (
          <DefaultAvatar
            avatar_url={`${process.env.REACT_APP_FILE_URL}/avatar/investor/${row?.original?.avatar}`}
            email={row?.original?.email}
            name={row?.original?.name}
          />
        ),
      },
      {
        header: "Invested Amount (₹)",
        accessorKey: "total_amount",
        enableColumnFilter: false,
        enableSorting: false,
        cell: ({ row }) => <>₹ {formatAmount(row.original.total_amount)}</>,
      },
      {
        header: "Commission Earned",
        accessorKey: "commission",
        enableColumnFilter: false,
        enableSorting: false,
        cell: ({ row }) => <>₹ {formatAmount(row.original.commission)}</>,
      },
      // {
      //   id: "action",
      //   header: "Actions",
      //   cell: ({ row }) => (
      //     <div className="d-flex justify-content-center align-items-center gap-3">
      //       <div className="action-view">
      //         <img
      //           src={eye}
      //           alt="view"
      //           onClick={() => {
      //             setOpen(true)
      //             console.log(row?.original.id)
      //           }}
      //         />
      //       </div>
      //       <div className="action-view">
      //         <Link
      //           to="#"
      //           id={`downloadTooltip-${row?.original?.id}`}
      //           onClick={() =>
      //             handleDownload(
      //               row.original.doc_url,
      //               row?.original?.agreement_ref || "ICD Master Agreement"
      //             )
      //           }
      //         >
      //           <img src={downloadIcon} alt="download" />
      //           <UncontrolledTooltip
      //             placement="top"
      //             target={`downloadTooltip-${row?.original?.id}`}
      //           >
      //             Download
      //           </UncontrolledTooltip>
      //         </Link>
      //       </div>
      //     </div>
      //   ),
      // },
    ]

    return headers
  }, [])

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <Breadcrumb title={"Commision Report"} />

          <div className="quarterterly-tds-table-wrapper">
            <TableContainer
              filters={filters}
              setFilters={setFilters}
              count={data.length}
              columns={columns}
              data={data}
              buttonName={"Invite"}
              isGlobalFilter={true}
              isCustomPageSize={false}
              isPagination={false}
              pagination="pagination"
              paginationWrapper="dataTables_paginate paging_simple_numbers"
              tableClass="table-bordered   table-nowrap dt-responsive nowrap w-100 dataTable no-footer dtr-inline"
            />
          </div>
        </Container>
      </div>
    </React.Fragment>
  )
}

export default InvestorCommissionReports
